import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

export default function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false }) {
  const { user, loading, isAdmin, isSuperAdmin } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  // Check if this is embed mode with API key (bypass auth for SDK embed)
  const isEmbed = searchParams.get('embed') === 'true';
  const hasApiKey = !!searchParams.get('api_key');
  
  // Allow embed mode with API key to bypass authentication
  // The component itself will handle API key validation
  if (isEmbed && hasApiKey) {
    return children;
  }

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Check super admin requirement
  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
